import type { SystemCallAction } from './systemCall.types';

export type { SystemCallAction } from './systemCall.types';

export const systemCallingAvailable = false;
export async function reportSystemIncomingCall(
  _callId: number,
  _displayName: string,
  _expiresAtEpochMs?: number,
): Promise<void> {}
export async function answerSystemCall(_callId: number): Promise<void> {}
export async function endSystemCall(_callId: number): Promise<void> {}
export async function getPendingSystemCallAction(): Promise<SystemCallAction | null> { return null; }
export function observeSystemCallActions(
  _listener: (action: SystemCallAction) => void,
): () => void { return () => {}; }
